import { Checkbox, TableCell, TableCellProps } from '@material-ui/core';
import React from 'react';

export type TableCheckboxCellProps = Omit<TableCellProps, "children" | "onChange"> & {
    checked: boolean
    onChange: (checked: boolean) => void
}

export function TableCheckboxCell ({checked, onChange, ...props}: TableCheckboxCellProps) {
    return (
        <TableCell padding="checkbox" {...props}>
            <Checkbox checked={checked} onChange={(_, c) => onChange(c)} />
        </TableCell>        
    )
}